export default __webpack_public_path__ + "static/media/Hon Lien.4b621646.jpg";